import { LoaderFunctionArgs, redirect } from "react-router";

export default async function teamsLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/teams/templates");
  return routeParams;
}
